import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";

import {
  Box,
  Button,
  Collapse,
  Divider,
  Typography,
} from "@mui/material";

import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";

import { UseAccess } from "../../Utils/getAccess";
import { RouteAccess } from "./MenuItems";

type Link = RouteAccess;

interface LinksGroupProps {
  label: string;
  icon?: React.ElementType; // ✅ FIXED (MUI-safe)
  accessCategory: string;
  initiallyOpened?: boolean;
  links?: Link[];
  link?: string;
  access?: string;
  category?: string;
}

export const LinksGroup: React.FC<LinksGroupProps> = ({
  label,
  icon: Icon,
  initiallyOpened = false,
  links,
  link,
  access,
  category,
}) => {
  const [opened, setOpened] = useState(initiallyOpened);

  const navigate = useNavigate();
  const user = useSelector((state: any) => state.user.user);

  const authorized = access
    ? UseAccess(access, category || "", label)
    : false;

  const handleToggle = () => {
    setOpened((prev) => !prev);
    if (link) navigate(link);
  };

  const IconComponent = Icon;

  if (!authorized) return null;

  return (
    <Box>
      {/* 🔷 PARENT BUTTON */}
      <Button
        fullWidth
        onClick={handleToggle}
        startIcon={IconComponent ? <IconComponent /> : null}
        endIcon={opened ? <ExpandLess /> : <ExpandMore />}
        sx={{
          justifyContent: "space-between",
          textTransform: "none",
          color: "text.primary",
          py: 1,
        }}
      >
        <Typography variant="body2">{label}</Typography>
      </Button>

      <Divider sx={{ my: 1 }} />

      {/* 🔷 CHILD LINKS */}
      {links && (
        <Collapse in={opened} timeout="auto" unmountOnExit>
          <Box sx={{ display: "flex", flexDirection: "column", ml: 2 }}>
            {links.map((linkItem) => {
              const authorizedLink = linkItem.canAccess(
                user.scope,
                user.category
              );

              if (!authorizedLink) return null;

              return (
                <Button
                  key={linkItem.label}
                  onClick={() => navigate(linkItem.path)}
                  sx={{
                    justifyContent: "flex-start",
                    textTransform: "none",
                    color: "text.secondary",
                    fontSize: 13,
                    py: 0.5,
                  }}
                >
                  {linkItem.label === "G2000"
                    ? user.company
                    : linkItem.label}
                </Button>
              );
            })}
          </Box>
        </Collapse>
      )}
    </Box>
  );
};